import { Box, Menu, MenuItem, Typography } from "@mui/material";

import { useEffect, useState, type MouseEvent } from "react";

import { theme } from "../../../utils/theme";

import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import {
  isPlantRowSelected,
  isSizeRowSelected,
} from "./utils/filterSelection";

interface IProps {
  all_size: any;
  categories: any;
  arrchoiceSize: any;
  arrchoicePlant: any;
  handleChoicePlant: (cate: any) => void;
  handleChoiceSize: (size: any) => void;
}
function FilterInMobile(props: IProps) {
  const {
    all_size,
    arrchoiceSize,
    arrchoicePlant,
    categories,
    handleChoicePlant,
    handleChoiceSize,
  } = props;

  const [valueDropDownPlant, setValueDropDownPlant] = useState("List");
  const [valueDropDownSize, setValueDropDownSize] = useState("All Sizes");

  const [anchorOptions, setAnchorOptions] = useState<HTMLElement | null>(null);
  const [anchorOptionsSize, setAnchorOptionsSize] = useState<HTMLElement | null>(
    null
  );
  const [categoryMenuWidth, setCategoryMenuWidth] = useState<number | null>(null);
  const [sizeMenuWidth, setSizeMenuWidth] = useState<number | null>(null);

  const handleOpenOptionsSize = (e: MouseEvent<HTMLElement>) => {
    setSizeMenuWidth(e.currentTarget.getBoundingClientRect().width);
    setAnchorOptionsSize(e.currentTarget);
  };
  const handleCloseOptionsSize = () => {
    setAnchorOptionsSize(null);
    setSizeMenuWidth(null);
  };
  const handleOpenOptions = (e: MouseEvent<HTMLElement>) => {
    setCategoryMenuWidth(e.currentTarget.getBoundingClientRect().width);
    setAnchorOptions(e.currentTarget);
  };
  const handleCloseOptions = () => {
    setAnchorOptions(null);
    setCategoryMenuWidth(null);
  };
  /** Full width trong cột — hai cột ngang (Categories | Size) */
  const filterDropdownButtonSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    minHeight: 40,
    flexShrink: 1,
    backgroundColor: "#E8ECE8",
    color: "#4E4747",
    border: "1px solid #7a8a7a",
    borderRadius: "5px",
    padding: "10px 8px",
    cursor: "pointer",
    boxSizing: "border-box" as const,
  };

  const filterColumnSx = {
    flex: "1 1 0%",
    minWidth: 0,
    display: "flex",
    flexDirection: "column" as const,
    gap: 0.75,
  };

  const filterLabelSx = {
    marginBottom: 0,
    color: "#4E4747",
    fontSize: { xs: 12, sm: 16 },
    fontWeight: 600,
    lineHeight: 1.2,
  };

  const getFilterMenuPaperProps = (anchorWidth: number | null) => ({
    sx: {
      mt: 0.5,
      minWidth: 0,
      /** Trùng chiều rộng ô dropdown khi đã đo; đóng menu thì fallback */
      width: anchorWidth != null ? `${anchorWidth}px` : "auto",
      maxWidth: anchorWidth != null ? `${anchorWidth}px` : "100%",
      maxHeight: "min(50vh, 280px)",
      overflowY: "auto",
      overflowX: "hidden",
      WebkitOverflowScrolling: "touch",
      borderRadius: "8px",
      py: 0.5,
      px: 0.5,
      boxSizing: "border-box" as const,
      boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
    },
  });

  const getFilterMenuItemSx = (selected: boolean) => ({
    minHeight: 40,
    py: 0.75,
    pl: 1.25,
    pr: 1.25,
    m: 0.25,
    borderRadius: "6px",
    display: "flex" as const,
    alignItems: "center" as const,
    justifyContent: "flex-start" as const,
    gap: 0,
    width: "100%",
    boxSizing: "border-box" as const,
    backgroundColor: selected ? "#E7F3E7" : "transparent",
    whiteSpace: "nowrap" as const,
    "&:hover": {
      backgroundColor: selected ? "#E7F3E7" : "rgba(0,0,0,0.05)",
    },
  });

  const getFilterMenuLabelSx = (active: boolean) => ({
    m: 0,
    p: 0,
    flex: 1,
    minWidth: 0,
    maxWidth: "100%",
    fontSize: 14,
    lineHeight: 1.3,
    fontWeight: active ? 500 : 400,
    textAlign: "left" as const,
    color: active ? "#263238" : "#979797",
    alignSelf: "center" as const,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
  });

  useEffect(() => {
    if (!categories || arrchoicePlant.length === 0) {
      setValueDropDownPlant("List");
      return;
    }
    const id = arrchoicePlant[0];
    const found = categories.find((x: any) => x.id === id);
    if (found?.name) setValueDropDownPlant(found.name);
  }, [arrchoicePlant, categories]);
  useEffect(() => {
    if (!all_size || arrchoiceSize.length === 0) {
      setValueDropDownSize("All Sizes");
      return;
    }
    const value = arrchoiceSize[0];
    const found = all_size.find((x: any) => x.value === value);
    if (found?.name) setValueDropDownSize(found.name);
  }, [arrchoiceSize, all_size]);
  return (
    <Box
      sx={(t) => ({
        display: { xs: "block", sm: "none" },
        /* Full-bleed: bù padding ngang PlantsPage (xs px 1.5) — nền sát mép */
        ml: { xs: t.spacing(-1.5), sm: 0 },
        mr: { xs: t.spacing(-1.5), sm: 0 },
        width: { xs: `calc(100% + ${t.spacing(3)})`, sm: "100%" },
        maxWidth: { xs: "none", sm: "100%" },
        boxSizing: "border-box",
        mt: 0,
        mb: 0,
        px: { xs: 2, sm: 1.5 },
        py: { xs: 1.5, sm: 1.75 },
        bgcolor: "#ebebeb",
        border: "none",
        borderRadius: 0,
        boxShadow: "none",
        borderBottom: "1px solid #cfcfcf",
        position: "relative",
        zIndex: 1,
      })}
    >
      <Typography
        sx={{
          fontWeight: 700,
          marginBottom: { xs: 0.75, sm: 1 },
          fontSize: { xs: 14, sm: 16 },
          color: theme.palette.common.green,
          letterSpacing: "0.02em",
        }}
      >
        Filter by
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          gap: { xs: 1.25, sm: 2 },
          width: "100%",
          minWidth: 0,
        }}
      >
        <Box sx={filterColumnSx}>
          <Typography sx={filterLabelSx}>Categories</Typography>
          <Box onClick={handleOpenOptions} sx={filterDropdownButtonSx}>
            <Typography
              sx={{
                color: "#4E4747",
                marginBottom: 0,
                mr: "4px",
                fontSize: { xs: 13, sm: 16 },
                fontWeight: 600,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                minWidth: 0,
                flex: "1 1 auto",
              }}
            >
              {valueDropDownPlant}
            </Typography>
            {anchorOptions === null ? (
              <KeyboardArrowDownOutlinedIcon
                sx={{
                  fontSize: { xs: 15, sm: 18 },
                  color: "#4E4747",
                  flexShrink: 0,
                }}
              />
            ) : (
              <KeyboardArrowUpOutlinedIcon
                sx={{
                  fontSize: { xs: 15, sm: 18 },
                  color: "#4E4747",
                  flexShrink: 0,
                }}
              />
            )}
          </Box>
        </Box>

        <Box sx={filterColumnSx}>
          <Typography sx={filterLabelSx}>Size</Typography>
          <Box onClick={handleOpenOptionsSize} sx={filterDropdownButtonSx}>
            <Typography
              sx={{
                color: "#4E4747",
                marginBottom: 0,
                mr: "4px",
                fontSize: { xs: 13, sm: 16 },
                fontWeight: 600,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                minWidth: 0,
                flex: "1 1 auto",
              }}
            >
              {valueDropDownSize}
            </Typography>
            {anchorOptionsSize === null ? (
              <KeyboardArrowDownOutlinedIcon
                sx={{
                  fontSize: { xs: 15, sm: 18 },
                  color: "#4E4747",
                  flexShrink: 0,
                }}
              />
            ) : (
              <KeyboardArrowUpOutlinedIcon
                sx={{
                  fontSize: { xs: 15, sm: 18 },
                  color: "#4E4747",
                  flexShrink: 0,
                }}
              />
            )}
          </Box>
        </Box>
      </Box>

      <Menu
        sx={{ mt: "35px" }}
        id="menu-appbar"
        anchorEl={anchorOptions}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorOptions)}
        onClose={handleCloseOptions}
        PaperProps={getFilterMenuPaperProps(categoryMenuWidth)}
        MenuListProps={{
          dense: true,
          sx: { p: 0, py: 0 },
        }}>
        {categories?.map((option: any, index: any) => {
          const selected = isPlantRowSelected(
            option?.id,
            arrchoicePlant,
            categories
          );
          return (
            <MenuItem
              key={index}
              disableRipple
              onClick={() => handleChoicePlant(option)}
              sx={getFilterMenuItemSx(selected)}>
              <Typography component="span" sx={getFilterMenuLabelSx(selected)}>
                {option?.name}
              </Typography>
            </MenuItem>
          );
        })}
      </Menu>

      <Menu
        sx={{ mt: "35px" }}
        id="menu-appbar-size"
        anchorEl={anchorOptionsSize}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorOptionsSize)}
        onClose={handleCloseOptionsSize}
        PaperProps={getFilterMenuPaperProps(sizeMenuWidth)}
        MenuListProps={{
          dense: true,
          sx: { p: 0, py: 0 },
        }}>
        {all_size?.map((option: any, index: any) => {
          const selected = isSizeRowSelected(
            option?.value,
            arrchoiceSize,
            all_size
          );
          return (
            <MenuItem
              key={index}
              disableRipple
              onClick={() => handleChoiceSize(option)}
              sx={getFilterMenuItemSx(selected)}>
              <Typography component="span" sx={getFilterMenuLabelSx(selected)}>
                {option?.name}
              </Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
}

export default FilterInMobile;
